import { withMetadata } from '../metadata'
import { findPhoneNumbersInText as _findPhoneNumbersInText } from '../../core/index'

export function findPhoneNumbersInText() {
	return withMetadata(_findPhoneNumbersInText, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/findPhoneNumbersInText.js
// module id = 628
// module chunks = 0